import React, { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import Breadcrumb from "./Breadcrumb";
import Footer from "./Footer";
import Header, {
  GridDropdownExample,
  SidebarDropdownExample,
  TableDropdownExample,
} from "./Header";
import MobileMenu from "./MobileMenu";
import Seo from "./Seo";
import { getCookie, removeCookie } from "../../common/auth";
import { useRouter } from "next/router";
import { showToastAlert } from "../../redux/action/alert";
import styled from "styled-components";
import ChannelTalk from "../channel/ChannelTalk";
import { isLoading, isLoaded } from "../../redux/action/loading";
import SideBanner from "./sideBanner";
import { setAllianceInfo } from "../../redux/action/alliance";
import { setBanners } from "../../redux/action/banners";
import { listSetBanners } from "../../api/banners";
import checkSiteConfig from "../../api/checkSiteConfig";
import { fetchUserInfo } from "../../redux/action/userInfo";
import ExitIntentBanner from "@components/layout/ExitIntentBanner";
const Body = styled.main``;

const Layout = ({
  dummyList,
  children,
  //START: breadcrumb
  parent,
  sub,
  subTitle,
  subChild,
  detailsubChild,
  noBreadcrumb,
  id,
  //END: breadcrumb
  headerStyle,
  showToastAlert,
  isLoading,
  isLoaded,
  allianceInfo,
  setAllianceInfo,
  setBanners,
  banners,
  fetchSiteInfo,
  siteConfig,
  //START: SEO
  pageTitle,
  pageDesc,
  pageImg,
  pageKeyword,
  //END: SEO
  userInfo,
  fetchUserInfo,
}) => {
  const router = useRouter();
  const [isToggled, setToggled] = useState(false);
  const [isSessionExpirated, setIsSessionExpirated] = useState(false);
  const [logo, setLogo] = useState({
    pc: "",
    mobile: "",
    over: "",
  });

  const toggleClick = () => {
    setToggled(!isToggled);
    isToggled
      ? document.querySelector("body").classList.remove("mobile-menu-active")
      : document.querySelector("body").classList.add("mobile-menu-active");
  };
  // 유저 정보 불러오는 함수 및 토큰 만료 시 분기 처리
  const getUser = async () => {
    await fetchUserInfo();
  };

  // 토큰 여부 파싱 후 유저 정보 불러오는 함수 트리거
  const isAccessTokenExisted = async () => {
    const accessToken = getCookie("token");

    if (accessToken) {
      getUser();
    } else {
      // gtag
      dataLayer.push({
        user_id: undefined,
      });
    }
  };

  const checkLogo = async () => {
    if (router.query.channel) {
      if (
        sessionStorage.getItem("logo") &&
        JSON.parse(sessionStorage.getItem("logo")).pc.includes("alliance")
      ) {
        setLogo(JSON.parse(sessionStorage.getItem("logo")));
      } else {
        const body = {
          modes: "Config",
          division: "store",
          channel: router.query.channel,
        };
        const res = await checkSiteConfig(body);

        setLogo({
          pc: res.Data.channel.logo,
          mobile: res.Data.channel.mobile_logo,
          over: res.Data.channel.over_logo,
        });
      }
    } else {
      if (dummyList) {
        setLogo({
          pc: dummyList.logo?.logo,
          mobile: dummyList.logo?.mobile_logo,
          over: dummyList.logo?.over_logo,
        });
      }
    }
  };

  const fetchBanners = async () => {
    const body = {
      modes: "ListSet",
    };
    const res = await listSetBanners(body);
    if (res?.Code === "0000") {
      setBanners(res?.Data?.rows);
    }
  };

  useEffect(() => {
    const channelTalk = new ChannelTalk();
    if (userInfo?.Member?.phone) {
      channelTalk.boot({
        pluginKey: process.env.NEXT_PUBLIC_CHANNELTALK_PLUGIN_KEY,
        memberId: userInfo?.Member.uid,
        profile: {
          name: userInfo?.Member.name,
          mobileNumber: userInfo?.Member?.phone,
          email: userInfo?.Member.email,
        },
      });
    } else {
      channelTalk.boot({
        pluginKey: process.env.NEXT_PUBLIC_CHANNELTALK_PLUGIN_KEY,
      });
    }
    return () => {
      channelTalk.shutdown();
    };
  }, [userInfo]);

  // 토큰 만료 시 toast 알림
  useEffect(() => {
    if (!router.isReady) return;
    checkLogo();
    isAccessTokenExisted();
    fetchBanners();

    const handleIsLoading = (e) => {
      isLoading();
    };
    const handleIsLoaded = (e) => {
      isLoaded();
    };

    router.events.on("routeChangeStart", handleIsLoading);

    router.events.on("routeChangeComplete", handleIsLoaded);

    return () => {
      router.events.off("routeChangeStart", handleIsLoading);

      router.events.off("routeChangeComplete", handleIsLoaded);
    };
  }, [router, router.query, dummyList]);

  const userCoupons = useMemo(() => {
    if (userInfo?.Coupon?.rows?.length > 0) {
      return userInfo?.Coupon;
    } else {
      return [];
    }
  }, [userInfo]);

  // 현재 경로 정보 활용을 위한 breadcrumb Ko data 생성
  const breadcrumbData = {
    parent: parent,
    sub: sub,
    subTitle: subTitle, // 1차 카테고리명 (예: "박스 테이프")
    subChild: subChild, // 2차 카테고리 또는 분류 (예: "친환경 포장")
    detailsubChild: detailsubChild, // 상세 제품명 (예: "리펄프테이프 48mm x 40M (60g) 3개")
  };

  return (
    <>
      <Seo
        title={pageTitle}
        desc={pageDesc}
        image={pageImg}
        keywords={pageKeyword}
        breadcrumbData={breadcrumbData}
        id={id}
      />
      {isToggled && (
        <div className="body-overlay-1" onClick={toggleClick}></div>
      )}
      {/*<SideBanner />*/}
      <Header
        headerStyle={headerStyle}
        isToggled={isToggled}
        toggleClick={toggleClick}
        userInfo={userInfo}
        logo={logo}
        userCoupons={userCoupons}
        siteConfig={siteConfig}
      />
      <MobileMenu
        isToggled={isToggled}
        toggleClick={toggleClick}
        userInfo={userInfo}
        userCoupons={userCoupons}
      />
      <Body className="main position-relative border-1">
        <Breadcrumb
          parent={parent}
          sub={sub}
          subTitle={subTitle}
          subChild={subChild}
          detailsubChild={detailsubChild}
          noBreadcrumb={noBreadcrumb}
          id={id}
        />
        <ExitIntentBanner />
        {children}
      </Body>
      <Footer />
    </>
  );
};

const mapStateToProps = (state) => ({
  allianceInfo: state.allianceInfo,
  banners: state.banners,
  dummyList: state.dummyList,
  userInfo: state.userInfo,
});

const mapDispatchToProps = {
  showToastAlert,
  isLoading,
  isLoaded,
  setAllianceInfo,
  setBanners,
  fetchUserInfo,
};

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
